import * as Yup from 'yup';

export const questionsSchema = Yup.object().shape({
  questions: Yup.array().of(Yup.object().shape({
    question: Yup.string().required('Required'),
    answers: Yup.array().of(Yup.object().shape({
      answer: Yup.string().required('Required'),
    })).min(2, 'Required 2 answers'),
  })),
});
